/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Closedeal_Toast_Success2Inputs */

const en_coinvestments_closedeal_toast_success2 = /** @type {(inputs: Coinvestments_Closedeal_Toast_Success2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deal closed successfully`)
};

/**
* | output |
* | --- |
* | "Deal closed successfully" |
*
* @param {Coinvestments_Closedeal_Toast_Success2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_closedeal_toast_success2 = /** @type {((inputs?: Coinvestments_Closedeal_Toast_Success2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Closedeal_Toast_Success2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_closedeal_toast_success2(inputs)
});
export { coinvestments_closedeal_toast_success2 as "coInvestments_closeDeal_toast_success" }